<template>
    <div>
        <div class="tab-pane">
            <div class="btn-base-client mt-3 pb-3">
                <div class="d-flex align-items-center gap-3">
                    <v-select
                        class="v-select"
                        id="selectCustomerFilter"
                        :options="applyedFiltersList"
                        v-model="selectedFilter"
                        label="display_name"
                        :placeholder="'Filters'"
                        hide-selected
                        :get-option-label="(option) => option.display_name"
                        @close="applyedFiltersChanged"
                        @input="onFilterChange"
                    >
                        <template #option="{ display_name }">
                            {{ display_name ?? 'Pas de filter' }}
                        </template>
                        <template v-slot:no-options="{ search, searching }">
                            <template v-if="searching">
                                Aucun résultat trouvé pour <em>{{ search }}</em
                                >.
                            </template>
                            <em v-else style="opacity: 0.5">Aucun élément n'est trouvé.</em>
                        </template>
                    </v-select>

                    <button
                        class="btn fs-sm btn-dark px-3 rounded-8 fw-medium"
                        v-if="applyedFiltersList.length > 0"
                        :disabled="isLoadingResetFilters"
                        @click="resetFilters"
                    >
                        <span v-if="isLoadingResetFilters">
                            <i class="fa fa-spinner fa-spin fa-fw"></i> Chargement..
                            <span class="sr-only">Chargement...</span>
                        </span>
                        <span v-else> <i class="fas fa-trash" title="Supprimer les filtres"></i> Effacer les filtres </span>
                    </button>
                </div>
            </div>
        </div>

        <div class="tab-pane" id="btabs-static-filters" role="tabpanel" aria-labelledby="btabs-static-filters-tab">
            <div class="block-content block-content-full mb-1 pt-5 pb-0 overflow-hidden">
                <form>
                    <div class="row justify-content-center">
                        <div class="col-sm-10 col-md-11">
                            <div class="row justify-content-center align-items-center">
                                <div class="row">
                                    <div class="col-6 col-xs-12">
                                        <label for="display_name" class="form-label">Nom du filtre</label>
                                        <input
                                            type="text"
                                            id="display_name"
                                            v-model="displayName"
                                            placeholder="Nom du filtre"
                                            class="form-control rounded-12"
                                        />
                                    </div>
                                </div>

                                <div class="row">
                                    <h3 class="text-center block-title fw-semibold text-light-blue pt-3 pb-1">
                                        Catégorie d'activité
                                    </h3>
                                    <div class="col-lg-6 col-xs-12">
                                        <label class="form-label">Catégorie d'activité (inclure)</label><br />
                                        <v-select
                                            class="v-select"
                                            id="selectFoodMenu"
                                            :options="prestationCategories"
                                            v-model="selectedPrestationCategoryInclude"
                                            label="name"
                                            :placeholder="'Catégorie d\'activité (inclure) '"
                                            multiple
                                            hide-selected
                                            :get-option-label="(option) => option.name"
                                        >
                                            <template #option="{ name }">
                                                {{ name }}
                                            </template>
                                            <template v-slot:no-options="{ search, searching }">
                                                <template v-if="searching">
                                                    Aucun résultat trouvé pour <em>{{ search }}</em
                                                    >.
                                                </template>
                                                <em v-else style="opacity: 0.5">Aucun élément n'est trouvé.</em>
                                            </template>
                                        </v-select>
                                    </div>
                                    <div class="col-lg-6 col-xs-12">
                                        <label class="form-label">Catégorie d'activité (exclure)</label><br />
                                        <v-select
                                            class="v-select"
                                            id="selectFoodMenu"
                                            :options="prestationCategories"
                                            v-model="selectedPrestationCategoryExclude"
                                            label="name"
                                            :placeholder="'Catégorie d\'activité (exclure) '"
                                            multiple
                                            hide-selected
                                            :get-option-label="(option) => option.name"
                                        >
                                            <template #option="{ name }">
                                                {{ name }}
                                            </template>
                                            <template v-slot:no-options="{ search, searching }">
                                                <template v-if="searching">
                                                    Aucun résultat trouvé pour <em>{{ search }}</em
                                                    >.
                                                </template>
                                                <em v-else style="opacity: 0.5">Aucun élément n'est trouvé.</em>
                                            </template>
                                        </v-select>
                                    </div>
                                </div>

                                <div class="row">
                                    <h3 class="text-center block-title fw-semibold text-light-blue pt-5">Activité effectuée</h3>
                                    <div class="col-lg-6 col-xs-12">
                                        <label class="form-label">Activité effectuée (inclure)</label><br />
                                        <v-select
                                            class="v-select"
                                            id="select"
                                            :options="prestations"
                                            v-model="selectedPrestationsInclude"
                                            label="name"
                                            :placeholder="'Activité effectuée (inclure)'"
                                            multiple
                                            hide-selected
                                            :get-option-label="(option) => option.name"
                                        >
                                            <template #option="{ name }">
                                                {{ name }}
                                            </template>
                                            <template v-slot:no-options="{ search, searching }">
                                                <template v-if="searching">
                                                    Aucun résultat trouvé pour <em>{{ search }}</em
                                                    >.
                                                </template>
                                                <em v-else style="opacity: 0.5">Aucun élément n'est trouvé.</em>
                                            </template>
                                        </v-select>
                                    </div>
                                    <div class="col-lg-6 col-xs-12">
                                        <label class="form-label">Activité effectuée (exclure)</label><br />
                                        <v-select
                                            class="v-select"
                                            id="select"
                                            :options="prestations"
                                            v-model="selectedPrestationsExclude"
                                            label="name"
                                            :placeholder="'Activité effectuée (exclure)'"
                                            multiple
                                            hide-selected
                                            :get-option-label="(option) => option.name"
                                        >
                                            <template #option="{ name }">
                                                {{ name }}
                                            </template>
                                            <template v-slot:no-options="{ search, searching }">
                                                <template v-if="searching">
                                                    Aucun résultat trouvé pour <em>{{ search }}</em
                                                    >.
                                                </template>
                                                <em v-else style="opacity: 0.5">Aucun élément n'est trouvé.</em>
                                            </template>
                                        </v-select>
                                    </div>
                                </div>

                                <div class="row">
                                    <h3 class="text-center block-title fw-semibold text-light-blue pt-5">Genre / Origine</h3>
                                    <div class="col-lg-6 col-xs-12">
                                        <label class="form-label">Genre</label><br />
                                        <v-select
                                            class="v-select"
                                            id="select"
                                            :options="genders"
                                            v-model="selectedGender"
                                            label="name"
                                            :placeholder="'Genre'"
                                            multiple
                                            hide-selected
                                            :get-option-label="(option) => option.name"
                                        >
                                            <template #option="{ name }">
                                                {{ name }}
                                            </template>
                                            <template v-slot:no-options="{ search, searching }">
                                                <template v-if="searching">
                                                    Aucun résultat trouvé pour <em>{{ search }}</em
                                                    >.
                                                </template>
                                                <em v-else style="opacity: 0.5">Aucun élément n'est trouvé.</em>
                                            </template>
                                        </v-select>
                                    </div>
                                    <div class="col-lg-6 col-xs-12">
                                        <label class="form-label">Origine</label>
                                        <v-select
                                            class="v-select"
                                            id="select"
                                            :options="origins"
                                            v-model="selectedOrigin"
                                            label="name"
                                            :placeholder="'Origine'"
                                            multiple
                                            hide-selected
                                            :get-option-label="(option) => option.name"
                                        >
                                            <template #option="{ name }">
                                                {{ name }}
                                            </template>
                                            <template v-slot:no-options="{ search, searching }">
                                                <template v-if="searching">
                                                    Aucun résultat trouvé pour <em>{{ search }}</em
                                                    >.
                                                </template>
                                                <em v-else style="opacity: 0.5">Aucun élément n'est trouvé.</em>
                                            </template>
                                        </v-select>
                                    </div>
                                </div>

                                <div class="row">
                                    <h3 class="text-center block-title fw-semibold text-light-blue pt-5">Anniversaire</h3>
                                    <div class="col-lg-6 col-xs-12">
                                        <label class="form-label mt-2">Né après le</label>
                                        <div>
                                            <date-picker
                                                v-model="birthdayAfterDate"
                                                format="DD-MM-YYYY"
                                                type="date"
                                                placeholder="Né après le "
                                            ></date-picker>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-xs-12">
                                        <label class="form-label mt-2">Né avant le</label>
                                        <div>
                                            <date-picker
                                                v-model="birthdayBeforeDate"
                                                format="DD-MM-YYYY"
                                                type="date"
                                                placeholder="Né avant le "
                                            ></date-picker>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <h3 class="text-center block-title fw-semibold text-light-blue pt-5">Âge</h3>
                                    <div class="col-lg-6 col-xs-12">
                                        <label class="form-label mt-2">Plus agé que</label>
                                        <input
                                            type="number"
                                            class="form-control mb-3 w-100"
                                            placeholder="Plus agé que "
                                            v-model="ageGreaterThan"
                                        />
                                    </div>
                                    <div class="col-lg-6 col-xs-12">
                                        <label class="form-label mt-2">Moins agé que</label>
                                        <input
                                            type="number"
                                            class="form-control mb-3 w-100"
                                            placeholder="Moins agé que "
                                            v-model="ageLesserThan"
                                        />
                                    </div>
                                </div>

                                <div class="row">
                                    <h3 class="text-center block-title fw-semibold text-light-blue pt-5">Points de fidélité</h3>
                                    <div class="col-lg-6 col-xs-12">
                                        <label class="form-label mt-2">Supérieur à</label>
                                        <input
                                            type="number"
                                            class="form-control mb-3 w-100"
                                            placeholder="Supérieur à"
                                            v-model="fidelityPointsGreaterThan"
                                        />
                                    </div>
                                    <div class="col-lg-6 col-xs-12">
                                        <label class="form-label mt-2">Inférieur à</label>
                                        <input
                                            type="number"
                                            class="form-control mb-3 w-100"
                                            placeholder="Inférieur à"
                                            v-model="fidelityPointsLesserThan"
                                        />
                                    </div>
                                </div>

                                <div class="row">
                                    <h3 class="text-center block-title fw-semibold text-light-blue pt-5">
                                        Date d'ajout / Intervalle de commandes
                                    </h3>
                                    <div class="col-lg-6 col-xs-12">
                                        <label class="form-label mt-2">Date d'ajout :</label>
                                        <v-select
                                            class="v-select"
                                            id="select"
                                            :options="addedOptions"
                                            v-model="selectedAdded"
                                            label="name"
                                            :placeholder="'Pas de sélection'"
                                            hide-selected
                                            :get-option-label="(option) => option.name"
                                        >
                                            <template #option="{ name }">
                                                {{ name }}
                                            </template>
                                            <template v-slot:no-options="{ search, searching }">
                                                <template v-if="searching">
                                                    Aucun résultat trouvé pour <em>{{ search }}</em
                                                    >.
                                                </template>
                                                <em v-else style="opacity: 0.5">Aucun élément n'est trouvé.</em>
                                            </template>
                                        </v-select>
                                    </div>
                                    <div class="col-lg-6 col-xs-12">
                                        <label class="form-label mt-2">Commande effectuée entre</label>
                                        <div class="">
                                            <date-picker
                                                v-model="orderDateRange"
                                                format="DD-MM-YYYY"
                                                type="date"
                                                range
                                                placeholder="Intervalle entre deux dates"
                                            ></date-picker>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <h3 class="text-center block-title fw-semibold text-light-blue pt-5">Date de réservation</h3>
                                    <div class="col-lg-6 col-xs-12">
                                        <label class="form-label mt-2">Passée après le</label>
                                        <div>
                                            <date-picker
                                                v-model="rdvAfterDate"
                                                format="DD-MM-YYYY"
                                                type="date"
                                                placeholder="Passée après le"
                                            ></date-picker>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-xs-12">
                                        <label class="form-label mt-2">Passée avant le</label>
                                        <div>
                                            <date-picker
                                                v-model="rdvBeforeDate"
                                                format="DD-MM-YYYY"
                                                type="date"
                                                placeholder="Passée avant le"
                                            ></date-picker>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center flex-wrap py-3 pb-0 my-4 px-6">
                        <button
                            class="btn btn-dark m-3 rounded-12 fw-semibold width-btn height_btn_page"
                            :disabled="applyFilterBtnIsDisabled"
                            @click="applayFilters"
                        >
                            <span v-if="isLoadingApplayFilters">
                                <i class="fa fa-spinner fa-spin fa-fw"></i>
                                <span class="sr-only">Chargement...</span>
                            </span>
                            <span v-else>
                                <span v-if="selectedFilter">Valider</span>
                                <span v-else>Ajouter</span>
                            </span>
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
// v-select
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
// datapicker
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/fr'
import ApiManager from './Api/ApiManagerBoCutomer.js'

export default {
    name: 'CustomerFilters',
    data() {
        return {
            displayName: '',
            prestationCategories: [],
            productCategories: [],
            prestations: [],
            products: [],
            origins: [],
            brands: [],
            selectedPrestationCategoryInclude: [],
            selectedPrestationCategoryExclude: [],
            selectedPrestationsInclude: [],
            selectedPrestationsExclude: [],
            selectedGender: '',
            selectedOrigin: '',
            birthdayAfterDate: '',
            birthdayBeforeDate: '',
            ageGreaterThan: '',
            ageLesserThan: '',
            fidelityPointsGreaterThan: '',
            fidelityPointsLesserThan: '',
            selectedAdded: '',
            orderAfterDate: '',
            orderDateRange: '',
            orderBeforeDate: '',
            rdvAfterDate: '',
            rdvBeforeDate: '',

            addedArray: [],
            prestations: [],

            genders: [{ name: 'Femme' }, { name: 'Homme' }, { name: 'Autre' }],

            addedOptions: [
                { name: "Aujourd'hui", value: 'today' },
                { name: 'Hier', value: 'yesterday' },
                { name: 'Cette semaine', value: 'this_week' },
                { name: 'La semaine passée', value: 'last_week' },
                { name: 'Ce mois', value: 'this_month' },
                { name: 'Le mois passé', value: 'last_month' },
                { name: 'Cette année', value: 'this_year' },
                { name: "L'année passée", value: 'last_year' },
            ],

            filter: '',
            result: '',
            isLoadingResetFilters: false,
            isLoadingApplayFilters: false,

            selectedFilter: [],
            applyedFiltersList: [],
        }
    },

    methods: {
        async fetchAllListsFilters() {
            try {
                const _data = await ApiManager.fetchAllListsForCustomerFilters()

                this.prestationCategories = _data?.prestationCategories ?? []
                this.productCategories = _data?.productCategories ?? []
                this.prestations = _data?.prestations ?? []
                this.products = _data?.products ?? []
                this.origins = _data?.origins ?? []
                this.brands = _data?.brands ?? []

                console.log('_data', _data)
            } catch (error) {
                this.$toast.error(error.response.data.message)
            }
        },

        async fetchApplyFilters() {
            try {
                const result = await ApiManager.fetchApplyFilters()
                this.applyedFiltersList = result?.userCustomFilter ?? []
            } catch (error) {
                this.$toast.error(error.response.data.message)
            }
        },

        async resetFilters() {
            await this.resetFiltersData()

            try {
                this.isLoadingResetFilters = true
                this.result = await ApiManager.applyFilters({
                    filter: 'reset',
                })
                if (this.result?.message != '') {
                    this.$toast.success(this.result?.message)
                }
            } catch (error) {
                this.$toast.error(error.response.data.message)
                //
            } finally {
                await this.fetchApplyFilters()
                this.selectedFilter = []
                this.isLoadingResetFilters = false
            }
        },

        initializeSelect2() {
            // Initialize Select2 here if needed
        },

        initializeFlatpickr() {
            // Initialize Flatpickr here if needed
        },

        async applayFilters() {
            const payload = {
                filter: 'apply',
                id: this.selectedFilter?.id,
                display_name: this.displayName,
                prestation_category_include: this.selectedPrestationCategoryInclude
                    ? this.selectedPrestationCategoryInclude.map((i) => i.id)
                    : [],
                prestation_category_exclude: this.selectedPrestationCategoryExclude
                    ? this.selectedPrestationCategoryExclude.map((i) => i.id)
                    : [],
                prestation_include: this.selectedPrestationsInclude ? this.selectedPrestationsInclude.map((i) => i.id) : [],
                prestation_exclude: this.selectedPrestationsExclude ? this.selectedPrestationsExclude.map((i) => i.id) : [],
                gender: this.selectedGender,
                origin_id: this.selectedOrigin ? this.selectedOrigin.map((i) => i.id) : [],
                birthday_after_date: this.birthdayAfterDate,
                birthday_before_date: this.birthdayBeforeDate,
                age_greater_than: this.ageGreaterThan,
                age_lesser_than: this.ageLesserThan,
                fidelity_points_greater_than: this.fidelityPointsGreaterThan,
                fidelity_points_lesser_than: this.fidelityPointsLesserThan,
                added: this.selectedAdded?.value ?? '',
                order_after_date:
                    Array.isArray(this.orderDateRange) && this.orderDateRange.length > 0 && this.orderDateRange[0]
                        ? moment(this.orderDateRange[0]).format('YYYY-MM-DD')
                        : '',
                order_before_date:
                    Array.isArray(this.orderDateRange) && this.orderDateRange.length > 1 && this.orderDateRange[1]
                        ? moment(this.orderDateRange[1]).format('YYYY-MM-DD')
                        : '',
                rdv_after_date: this.rdvAfterDate ?? '',
                rdv_before_date: this.rdvBeforeDate ?? '',
            }

            try {
                this.isLoadingApplayFilters = true
                this.result = await ApiManager.applyFilters(payload)
                this.selectedFilter = this.result?.data ?? []

                if (this.result?.message != '') {
                    this.$toast.success(this.result?.message)
                }

                this.$emit('valide')
            } catch (error) {
                this.$toast.error(error.response.data.message)
                //
            } finally {
                this.fetchApplyFilters()
                this.isLoadingApplayFilters = false
            }
        },

        resetFiltersData() {
            this.filter = 'reset'
            this.displayName = ''
            this.selectedPrestationCategoryInclude = []
            this.selectedPrestationCategoryExclude = []
            this.selectedPrestationsInclude = []
            this.selectedPrestationsExclude = []
            this.selectedGender = []
            this.selectedOrigin = []
            this.birthdayAfterDate = []
            this.birthdayBeforeDate = []
            this.ageGreaterThan = []
            this.ageLesserThan = []
            this.fidelityPointsGreaterThan = []
            this.fidelityPointsLesserThan = []
            this.selectedAdded = []
            this.orderDateRange = []
            this.rdvAfterDate = []
            this.rdvBeforeDate = []
        },

        async setFilterData(displayName, _filters) {
            if (!_filters) return

            await this.resetFiltersData()

            this.displayName = displayName ?? ''

            // prestation_category_include
            if (_filters.prestation_category_include) {
                _filters.prestation_category_include.forEach((_id) => {
                    const _find = this.prestationCategories.find((x) => x.id == _id)
                    if (_find) {
                        this.selectedPrestationCategoryInclude.push({
                            id: _find.id,
                            name: _find.name,
                        })
                    }
                })
            }

            // prestation_category_exclude
            if (_filters.prestation_category_exclude) {
                _filters.prestation_category_exclude.forEach((_id) => {
                    const _find = this.prestationCategories.find((x) => x.id == _id)
                    if (_find) {
                        this.selectedPrestationCategoryExclude.push({
                            id: _find.id,
                            name: _find.name,
                        })
                    }
                })
            }

            // prestation_include
            if (_filters.prestation_include) {
                _filters.prestation_include.forEach((_id) => {
                    const _find = this.prestations.find((x) => x.id == _id)
                    if (_find) {
                        this.selectedPrestationsInclude.push({
                            id: _find.id,
                            name: _find.name,
                        })
                    }
                })
            }

            // prestation_exclude
            if (_filters.prestation_exclude) {
                _filters.prestation_exclude.forEach((_id) => {
                    const _find = this.prestations.find((x) => x.id == _id)
                    if (_find) {
                        this.selectedPrestationsExclude.push({
                            id: _find.id,
                            name: _find.name,
                        })
                    }
                })
            }

            if (_filters.origin_id) {
                _filters.origin_id.forEach((_id) => {
                    const _find = this.origins.find((x) => x.id == _id)
                    if (_find) {
                        this.selectedOrigin.push({
                            id: _find.id,
                            name: _find.name,
                        })
                    }
                })
            }

            if (_filters.added) {
                const _find = this.addedOptions.find((x) => x.value == _filters.added)
                if (_find) {
                    this.selectedAdded.push(_find)
                }
            }

            this.selectedGender = _filters.gender ?? ''

            this.birthdayAfterDate = this.varifyDate(_filters.birthday_after_date)
                ? moment(_filters.birthday_after_date).toDate()
                : ''
            this.birthdayBeforeDate = this.varifyDate(_filters.birthday_before_date)
                ? moment(_filters.birthday_before_date).toDate()
                : ''

            this.ageGreaterThan = _filters.age_greater_than ?? ''
            this.ageLesserThan = _filters.age_lesser_than ?? ''

            this.fidelityPointsGreaterThan = _filters.fidelity_points_greater_than ?? ''
            this.fidelityPointsLesserThan = _filters.fidelity_points_lesser_than ?? ''

            this.orderDateRange.push(
                this.varifyDate(_filters.order_after_date) ? moment(_filters.order_after_date).toDate() : '',
                this.varifyDate(_filters.order_before_date) ? moment(_filters.order_before_date).toDate() : ''
            )

            this.rdvAfterDate = this.varifyDate(_filters.rdv_after_date) ? moment(_filters.rdv_after_date).toDate() : ''
            this.rdvBeforeDate = this.varifyDate(_filters.rdv_before_date) ? moment(_filters.rdv_before_date).toDate() : ''
        },

        varifyDate(date) {
            return date && moment(date).isValid() ? moment(date).toDate() : ''
        },

        applyedFiltersChanged() {
            console.log('applyedFiltersChanged', this.selectedFilter)
            this.setFilterData(this.selectedFilter?.display_name, this.selectedFilter?.filters)
            // this.$emit('selected-apply-filter-changed', this.selectedFilter?.id ?? '')
        },

        onFilterChange(value) {
            if (value == null) {
                this.resetFiltersData()
            }
        },
    },
    async mounted() {
        await this.fetchAllListsFilters()
        this.fetchApplyFilters()
    },
    computed: {
        applyFilterBtnIsDisabled() {
            return this.isLoadingApplayFilters || this.displayName == ''
        },
    },
    components: {
        vSelect,
        DatePicker,
    },
}
</script>

<style scoped>
.mx-datepicker {
    width: 100%;
}
.mx-input {
    padding: 1rem;
    color: #94a3b8;
    background-color: #fff;
    border-color: #e2e8f0;
    border-radius: 12px;
    font-size: 16px;
    height: 56px;
    cursor: pointer;
}
.mx-calendar-content .cell.active {
    background-color: #021832;
    font-weight: 600;
}
.mx-table-date .today {
    color: #021832;
}

.loader {
    border: 4px solid rgba(0, 0, 0, 0.1);
    border-left-color: #7986cb; /* Change color as needed */
    border-radius: 50%;
    width: 24px;
    height: 24px;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
.mx-calendar-content .cell {
    border-radius: 12px;
}
.mx-icon-calendar,
.mx-icon-clear {
    top: 48% !important;
    right: 17px !important;
    cursor: pointer !important;
    color: #94a3b8 !important;
    font-size: 22px !important;
}

#selectCustomerFilter {
    min-width: 206px;
}

#selectCustomerFilter .v-select .vs__dropdown-toggle {
    max-height: 40px !important;
}
</style>
